import React from 'react';
import {AgGridColumn} from "../../../components/agGridColumn";
import Grid, {ListaMultiplaFilter} from '../../../components/grid';
import { ActionProps } from '../../../components/gridAction';
import enumDescription from "../../../services/enumDescription";
import {GridApi} from "ag-grid-community";


const RelatorioRetrospectivaList = (props:any) => {


    const actions: Array<ActionProps> = [
        {
            route:'relatorio-retrospectiva/incluir',
            color:'success',
            type:'normal',
            title:'Incluir'
        },
        {
            route:'relatorio-retrospectiva/alterar',
            color:'warning',
            type:'grid',
            title:'Alterar'
        },
        {
            route:'relatorio-retrospectiva/delete',
            color:'danger',
            type:'delete',
            title:'Excluir',
        },
        {
            route:'impressao-retrospectiva',
            color:'info',
            type:'grid',
            title:'Imprimir Relatório',
            openInNewTab: true
        },

    ];

    return (
        <Grid actions={actions} rota="relatorio-retrospectiva/list" >
            <AgGridColumn headerName="#" width={90} checkboxSelection field="id"  sortable={ true } filter={ 'agNumberColumnFilter'}></AgGridColumn>
            <AgGridColumn headerName="Título"  field="titulo" flex={1} sortable={ true } filter={ true }></AgGridColumn>
            <AgGridColumn headerName="data"    field="data" sortable={ true } flex={1} filter={ 'agDateColumnFilter'}></AgGridColumn>
            <AgGridColumn headerName="Usuario" field="usuario/nome" flex={1} sortable={ true } filter={ true }></AgGridColumn>
        </Grid>
    );
};


export default RelatorioRetrospectivaList;